import { StyleSheet } from 'aphrodite';

export default StyleSheet.create({
  container: {
    paddingTop: 40,
    paddingBottom: 80,
    alignSelf: 'center',
    width: 700,
  },

  choiceBox: {
    flexDirection: 'row',
    flexWrap: 'wrap',
  },

  choice: {
    padding: '9px 10px',
    marginRight: 10,
    marginBottom: 10,
    lineHeight: 1.8,
    backgroundColor: '#EAEFF2',
    borderRadius: '4px',
    border: 'none',
    cursor: 'pointer',
    wordWrap: 'break-word',
    maxWidth: '100%',
  },

  choiceAnswerBox: {
    marginTop: 40,
  },

  choiceAnswer: {
    marginRight: 10,
    marginBottom: 10,
    minWidth: 200,
    minHeight: 40,
    border: '1px solid #C3CCD1',
    borderRadius: '4px',
  },

  cursorDefault: {
    cursor: 'default',
  },

  choiceChecked: {
    backgroundColor: '#F7F8FA',
    cursor: 'not-allowed',
    color: '#C3CCD1',
  },

  reportItemRichText: {
    marginBottom: '-20px',
  },

  reportItemText: {
    flex: 1,
    flexWrap: 'nowrap',
    paddingRight: '25px',
    lineHeight: '24px',
  },
});



// WEBPACK FOOTER //
// ./src/components/questions/select/styles.js